export default "__VITE_ASSET__CSL0eN5Q__"